import { useState } from "react";
import { TQuizAttempt } from "../../../entities/Moodle/model/MoodleTypes";

interface useMoodleGameProps {}

export const useMoodleGame = ({}: useMoodleGameProps) => {
  const [questions, setQuestions] = useState<any[]>([]);
  const [attempt, setAttempt] = useState<TQuizAttempt | null>(null);
  const [isQuestionModalOpened, setIsQuestionModalOpened] =
    useState<boolean>(false);
  return {
    questions,
    setQuestions,
    attempt,
    setAttempt,
    isQuestionModalOpened,
    setIsQuestionModalOpened,
  };
};
